import about from './en/about'
import product from './en/product'
import matpl from './en/p_matpl'
import pwmodule from './en/p_module'
import pwkit from './en/p_pwkit'
import qflow from './en/p_qflow'
import qstudio from './en/p_qstudio'
import allinone from './en/p_allinone'
import gpu from './en/download/pwmat'
import ls3df from './en/download/ls3df'
import potential from './en/download/potential'
import utility from './en/download/utility'
import more from './en/more'

export default{
  ...about,
  ...product,
  ...matpl,
  ...pwmodule,
  ...pwkit,
  ...qflow,
  ...qstudio,
  ...allinone,
  ...gpu,
  ...ls3df,
  ...potential,
  ...utility,
  ...more,
  language: {
    name: 'EN'
  },
  navbar: {
    Home:'Home',
    About:'about Us',
    CompanyProfile:'Company Profile',
    CompanyNews:'Product Overview',
    AcademicDemo: 'Academic Education Program',
    IndustryDemo: 'Industry Solutions',
    Customers: 'Our customers',
    ContactUs:'Contact Us',
    JoinUs:'Join us',
    product:'product',
    Trial: 'Limited-time trial',
    Solution:'Software and hardware integration',
    Features: 'Special Feature Modules',
    Forum:'forum',
    Video:'Video Tutorial',
    Download:'download',
    SoftWareDownload:'PWmat',
    PWmatGPU:'GPU version',
    PWmatDCU:'DCU version',
    PWmatCPU:'CPU version',
    PWmatWin:'Windows version',
    PWmatTry:'Free Trial License',
    PotentialDownload:'Pseudopotential',
    PWmatManual:'PWmat manual',
    PWmatzhVer:'Chinese version',
    PWmatenVer:'English version',
    QflowManual:'Q-Flow manual',
    QstudioManual:'Q-Studio manual',
    Course:'Resource Center',
    Tutorial:'User Guide',
    CommonParameter:'Common Parameters Explained',
    TypicalLiterature:'Typical literature reproduction',
    PublishedPapers:'Published papers',
    ModuleClassroom:'Module small classroom',
    GettingStartedVideo:'Getting Started Tutorial Video',
    SpecialVideo:'Special course videos',
    SpecialVideo2:'Training Camp Special Course Video',
    SpecialVideo3:'Q-Studio Modeling Tips',
    BigVideo:'Expert lectures video',
    BigVideo2:'Expert lectures',
    BigVideo3:'LongXun forum',
    BigVideo4:'Longxun Seminar',
    BigVideo5:'Conference Report',
    More:'More',
    Log:'Update Log',
    BugLog: 'Bug Log',
    Paper:'Paper',

  },
  footer:{
    QuickLink:'Quick Links',
    FriendlyLink:'Friendly Links',
    Company:'Beijing Longxun Kuangteng Technology Co.',
    JoinUs:'Careers',
    Tutorials:'Tutorials',
    Trial:'Trial Version',
    forum: 'LongXun Forum',
    link01: 'Peking University New Materials',
    phone1: 'Sales Tel:',
    phone2: 'Market phone:',
    wechat: 'WeChat official account',
  },
  carousel:{
    title1:'Intelligent Materials R&D Platform IntelliMat',
    subtitle1:'Knowledge base, tool execution, professional skills, and workflow orchestration',
    button1:'Learn more',
    title2:'Q-studio AI',
    subtitle2:'An AI materials computing agent that integrates large language models and interactive capabilities',
    title3:'Machine Learning Force Field Software MatPL',
    subtitle3:'Achieved the world’s first DFT-accuracy trillion-atom molecular dynamics simulation',
    title4:'Atomic-scale Materials Intelligent Computing All-in-one Machine QStation',
    subtitle4:'Accurate modeling, intelligent combination, intelligent optimization, insight into material properties, and graphical presentation',
    title5:'PWmat Featured Capabilities',
    subtitle5:'Fast HSE, Electron-Phonon Coupling, rt-TDDFT, NAMD, Solvent Model, Charge Patching Method',
    title6:'Free 6-Month DFT Computing Package PWstudio',
    subtitle6:'Integrated installation package with full-featured PWmat, visual workflow Q-Flow, and online modeling Q-Studio',
  },
  home: {
    productlist: 'Featured Products',
    allinone: 'All-in-one',
    about: 'Supercomputing Cloud',
    mcloud: `Mcloud is a supercomputing cloud platform consisting of high-performance clusters and cloud desktops built by Longxun Kuangteng.
      The cloud platform integrates software such as PWmat, Q-Flow, Q-Studio and Lammps, and provides SaaS material simulation computing services.
      Users can complete registration independently. After registration, they can use software such as PWmat and rich GPU card time resources online.
      `,
    register: 'Click to register',
    PWstudio: 'Limited-Time 6-Month Trial Installation Package PWstudio',
    PWstudioIntroductor: 'PWstudio is a one-click installation package that integrates PWmat, the Q-Flow visual workflow tool, and the Q-Studio modeling tool. It provides a six-month trial from the date of registration. The PWmat license includes optimized CPU and GPU versions. Users must provide their own CPU or GPU servers and independently complete environment setup, service installation, deployment, and verification. The license automatically expires after six months.',
    IntelliMat: 'Intelligent Materials R&D Platform IntelliMat',
    IntelliMatIntroductor: 'IntelliMat is an intelligent work platform for the full materials R&D process. Beyond interactive AI Q&A, it systematically builds capabilities across four core layers: knowledge bases, tool execution, professional Skills, and workflow orchestration. Its Superflow workflow orchestration module is a distinctive capability not offered by other Agent platforms in this field. It transforms one-off Agent executions into standardized R&D processes that can be saved, reproduced, scheduled, and published, resolving irreproducible tasks caused by environmental differences, version changes, and manual operations, reducing inconsistent AI results across runs, and explicitly preserving critical steps, parameters, and computational resources.',
    click: 'Learn more',
    news: 'Company News',
    honor: 'Honors & Awards',
    ecological: 'Ecosystem Construction',
    Strategic: 'Strategic Cooperation',
    cooperate: 'Partners',
  }
}
